import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { ShareState } from "source/app/services/UI/State/ShareState";
import { PrayerBody } from "./Body/PrayerBody";
import { PrayerHistory } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/Prayer/History/PrayerHistory";

export interface IPrayerState {
    headerProblem: string;
    bodyTexts: string[];
}

export function Prayer() {
    const [state, setState] = React.useState<IPrayerState>({
        headerProblem: "",
        bodyTexts: [],
    });

    ShareState(ESharedFunction.Prayer_state, state, setState);

    return (
        <div
            style={{
                textAlign: `center`,
                margin: "20px",
                borderRadius: "6px",
                background: "rgb(0 0 0 / 15%)",
                padding: "10px",
            }}
        >
            <PrayerHistory {...{ state }} />
            <PrayerBody />
        </div>
    );
}


